import { ProjectUserRoleGeneratedEntity } from "./generated/ProjectUserRoleGeneratedEntity";

export abstract class ProjectUserRoleEntity extends ProjectUserRoleGeneratedEntity {
    // Comment to preserve new line
}
